import ContactUsComponent from '../components/contact-us/contactUs'

const ContactUs = () => <ContactUsComponent />

export default ContactUs;